import type { ReactNode } from 'react';

import { colors } from '@packages/core/styles';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
    listItem: {
        alignItems: 'flex-start',
        color: colors.blueLink,
        display: 'flex',
        listStyle: 'none',
        '&::before': {
            content: '"\\2022"',
            flexShrink: 0,
            fontSize: 15,
            lineHeight: '24px',
            marginRight: '8px',
        },
    },
});

export type CvtConcernDocListItemProps = {
    children: ReactNode;
};

export function CvtConcernDocListItem({ children }: CvtConcernDocListItemProps) {
    const classes = useStyles();

    return <li className={classes.listItem}>{children}</li>;
}
